export const getCssPropertyValue = (propertyName: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(propertyName).trim();
